import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import Product from '../../../../model/product/product';
import ProductHelper from 'src/app/helpers/product-helper';
import { Project } from 'src/app/model/project/project';
import { ProjectDisplayObservableService } from 'src/app/services/project-display-observable.service';
import { SubscriptionBasedComponent } from 'src/app/subscription-helpers/subscription-based.component';
import ProjectHelper from 'src/app/helpers/project-helper';
import OtherProduct from '../../../../model/product/other-product/other-product';

@Component({
  selector: 'design-picker',
  templateUrl: './design-picker.component.html',
  styleUrls: ['./design-picker.component.scss'],
})
export class DesignPickerComponent
  extends SubscriptionBasedComponent
  implements OnInit
{
  @Input()
  public inputProduct: Product;

  @Input()
  public inputProject: Project;

  @Input()
  public client = false;

  @Input()
  public disabled = false;

  @Output()
  public updateProduct = new EventEmitter();

  displayImmoscoopOption: boolean = false;
  displaySpottoOption = false;
  otherProductName: string;

  constructor(
    private projectDisplayObservableService: ProjectDisplayObservableService
  ) {
    super();
  }

  ngOnInit() {
    this.calculateDisplayImmoscoopOption();
    this.calculateDisplaySpottoOption();

    this.addSubscription(
      this.projectDisplayObservableService.getProjectContactsChangedSubscribable(),
      () => {
        this.calculateDisplayImmoscoopOption();
        this.calculateDisplaySpottoOption();
      }
    );
    if (ProductHelper.isOtherProduct(this.inputProduct)) {
      this.otherProductName = (<OtherProduct>(
        this.inputProduct
      )).otherProductName;
      this.addSubscription(
        this.projectDisplayObservableService.getProductMaterialChangedSubscribable(),
        () => {
          this.otherProductName = (<OtherProduct>(
            this.inputProduct
          )).otherProductName;
        }
      );
    }
  }

  isWindowSticker() {
    return ProductHelper.isWindowSticker(this.inputProduct);
  }

  isBoard() {
    return ProductHelper.isBoard(this.inputProduct);
  }

  fileOptionSelected(event) {
    this.inputProduct.newDesign = event.value;
    this.updateProduct.emit();
  }

  fileOptionUpload(event) {
    this.updateProduct.emit();
  }

  immoscoopLogoChanged(event: boolean) {
    this.inputProduct.immoscoopLogo = event;
    this.updateProduct.emit();
  }

  spottoLogoChanged(event: boolean) {
    this.inputProduct.spottoLogo = event;
    this.updateProduct.emit();
  }

  calculateDisplayImmoscoopOption(): void {
    this.displayImmoscoopOption =
      ProjectHelper.displayImmoscoopOptionForProjectContacts(
        this.inputProject.projectContacts
      );
  }

  calculateDisplaySpottoOption(): void {
    this.displaySpottoOption =
      ProjectHelper.displaySpottoOptionForProjectContacts(
        this.inputProject.projectContacts
      );
  }
}
